import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Header from '../../Header/Header';
import { history } from '../../helpers/history';
import { Helmet } from "react-helmet";
import { gameActions } from '../../action/GameAction';
import HomeSlidTabs from '../../Pages/Home/HomeSlidTabs';
class BuyJackpotOnlineMY extends Component {
    constructor(props) {
        super(props);

        const queryParams = new URLSearchParams(window.location.search);
        const Query_bonus_id = queryParams.get("bonus_id");
        this.state = {
            locadet: window.location.pathname.split('/')[window.location.pathname.split('/').length - 1].toLowerCase(),
            bonus_id: Query_bonus_id ? Query_bonus_id : 0
        }
        this.props.getbonusperuser(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey)
    }

    ClickGame = (idclk) => {
        history.push(idclk)
    }

    static getDerivedStateFromProps(props, state) {
        return { bonus_details: props.bonus_details };
    };


    capitalizeFirstLetter = (str) => {
        if (!str) return ""; // handle empty string
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    render() {
        const { t } = this.props;
        const { i18n } = this.props;

        return (
            <div>
                {process.env.REACT_APP_MODE != "development" &&
                    <Helmet>
                        <title>Buy Jackpot Online in Malaysia – Win Big with Gulf Ticket</title>
                        <meta name="description" content="Learn how Malaysians can safely buy Gulf Ticket jackpot tickets online and explore games like Magic 5 and Fortune 4 for more chances to win huge prizes." />
                        <meta name="keywords" content="TOTO online betting Malaysia, Malaysia TOTO results" />
                        <meta property="og:title" content={`Buy Jackpot Online in Malaysia – Win Big with Gulf Ticket`} />
                        <meta property="og:site_name" content="Gulf Ticket" />
                        <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                        <meta property="og:description" content="Learn how Malaysians can safely buy Gulf Ticket jackpot tickets online and explore games like Magic 5 and Fortune 4 for more chances to win huge prizes." />
                        <meta property="og:type" content="website" />
                        <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                    </Helmet>
                }
                <div className="mainContainer bg5">
                    <Header />
                    <div class="container">
                        <HomeSlidTabs />
                        <div class="rht bg2 content">
                            <div class="bredCrums">
                                <ul>
                                    <li><a onClick={() => { history.push('/') }}> {t('lblHome')}<img src="./assets/img/icons/right-angle.png" /></a></li>
                                    <li><a class="active">Bonus Details</a></li>
                                </ul>
                            </div>
                            <div class="depositPop">
                                {this.state.bonus_details && this.state.bonus_details.array && this.state.bonus_details.array.length > 0 && this.state.bonus_details.array.filter(a => this.state.bonus_id == 0 || this.state.bonus_id == a.bonus_id).map((item, inx1) =>
                                    <>
                                        <h2 >{inx1 + 1}. {item.bonus_name}</h2>
                                        <ul>
                                            {Object.keys(item).map((key) => (
                                                <>
                                                    {key != 'bonus_name' && key != 'bonus_id' && <li>
                                                        <div class="w-20"><span class="ft">{this.capitalizeFirstLetter(key.replaceAll("_", " "))}:</span></div>
                                                        <div class="w-60"><span>{item[key]}</span></div>
                                                    </li>}
                                                </>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }

}

function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { bonus_details } = state.gameReducer;
    return { user, appvariables, bonus_details };
}
const mapActionToProps = {
    getbonusperuser: gameActions.getbonusperuser
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(BuyJackpotOnlineMY))